import { V3Record } from 'data/helpers/V3Record.js'

export const Segment = V3Record('segment', {
  createdAt: null,
  updatedAt: null,
  mongoId: null,
  trackId: null,
  userId: null,
  groupId: null,
  eventId: null,
  createdFromType: null,
  createdFromId: null,
  title: null,
  slug: null,
  matchingScope: null,
  surrogate: null,
  finalTimeSource: null,
  swLat: null,
  swLng: null,
  neLat: null,
  neLng: null,
  firstLat: null,
  firstLng: null,
  lastLat: null,
  lastLng: null,
  postalCode: null,
  countryCode: null,
  administrativeArea: null,
  locality: null,
  startsOn: null,
  endsOn: null,
  distance: null,
  eleGain: null
})
